import { render, staticRenderFns } from "./TradeList.vue?vue&type=template&id=3b78be3d&scoped=true"
import script from "./TradeList.vue?vue&type=script&lang=js"
export * from "./TradeList.vue?vue&type=script&lang=js"
import style0 from "./TradeList.vue?vue&type=style&index=0&id=3b78be3d&prod&lang=scss&scoped=true"
import style1 from "./TradeList.vue?vue&type=style&index=1&id=3b78be3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b78be3d",
  null
  
)

export default component.exports